import React from 'react';
import PropTypes from 'prop-types';
import { connectStateResults } from 'react-instantsearch-dom';

// Only claim "You have matches!" once the search has actually returned some. The page runs a
// search built from the user's hashtags, and that search can come back empty or fail outright.
export function MatchesBanner({ searchResults }) {
  if (!searchResults || searchResults.nbHits === 0) return null;

  return (
    <div className="p-4 mb-4 position-relative overflow-hidden" style={{ backgroundColor: '#f1effe' }}>
      <h2 className="fw-bold text-xl mb-2" style={{ color: '#463991', fontSize: '24px' }}>You have matches!</h2>
      <p className="text-gray-600" style={{ fontSize: '16px' }}>Connect with media users who write about topics that match your expertise</p>

      <svg
        style={{
          position: 'absolute',
          right: '-20px',
          bottom: '-20px',
          width: '300px',
          height: '200px',
          pointerEvents: 'none',
        }}
      >
        <circle
          cx="250"
          cy="150"
          r="100"
          fill="rgba(124, 58, 237, 0.1)"
        />
        <circle
          cx="200"
          cy="180"
          r="80"
          fill="rgba(124, 58, 237, 0.15)"
        />
      </svg>
    </div>
  );
}

MatchesBanner.propTypes = {
  searchResults: PropTypes.instanceOf(Object),
};

MatchesBanner.defaultProps = {
  searchResults: undefined,
};

export default connectStateResults(MatchesBanner);
